<template>
  <div class="relative w-[300px] sm:w-[332px] sm2:w-[400px] md:w-[500px]">
    <div
      class="absolute left-36 top-0 z-0 size-52 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#11bf85b3] blur-[240px] md:left-0 md:size-[304px]"
    />
    <div
      class="right-side-bg absolute bottom-0 right-36 z-0 size-52 translate-x-1/2 translate-y-1/2 rounded-full bg-warning-850 blur-[220px] md:right-0 md:size-[304px]"
    />
    <div
      class="relative z-10 rounded-2xl border border-secondary-800 bg-white p-6 md:p-8"
      style="box-shadow: 0px 0px 20px 0px rgba(0, 35, 31, 0.04), 0px 0px 0px 16px rgba(255, 255, 255, 0.40);"
    >
      <div class="space-y-4 text-center md:space-y-6">
        <div class="flex items-center justify-center">
          <InstaWpIcon class="max-h-12 max-w-44" />
        </div>
        <div class="text-xl font-semibold text-grayCust-430 md:text-[28px]">
          Welcome to <span class="text-primary-900">{{ setting.brandName }}</span>
        </div>
        <div
          v-if="plugin_theme_arr.length"
          class="space-y-2 bg-grayCust-50 p-2 md:p-3"
        >
          <span class="text-xs font-medium text-grayCust-620 md:text-sm">You are about to try...</span>
          <div class="flex items-center justify-center gap-x-2">
            <button
              v-for="(item, index) in plugin_theme_arr"
              :key="index"
              type="button"
              class="rounded-md border border-grayCust-390 bg-grayCust-770 px-2 py-1 text-xs font-medium text-grayCust-620"
            >
              {{ item }}
            </button>
          </div>
        </div>
        <jet-validation-errors class="mb-4" />

        <div
          v-if="status"
          class="mb-4 text-sm font-medium text-green-600"
        >
          {{ status }}
        </div>
        <form
          :action="route('login')"
          method="post"
          class=""
        >
          <input
            type="hidden"
            name="isModalLogin"
            :value="isModalLogin"
          >
          <input
            type="hidden"
            name="redirect"
            :value="redirect"
          >
          <input
            type="hidden"
            name="_token"
            :value="csrf_token"
          >
          <input
            type="hidden"
            name="timezone"
            :value="timezone"
          >
          <div
            :class="setting.googleLoginEnabled || setting.facebookLoginEnabled || setting.twitterLoginEnabled ? 'h-full md:max-h-[325px] max-h-[260px]' : 'h-full md:max-h-[270px] max-h-[230px]'"
            class="mb-6 space-y-2 md:space-y-4"
          >
            <div class="flex items-center justify-center gap-x-4 md:justify-between md:flex-nowrap flex-wrap gap-y-3">
              <a
                v-if="setting.googleLoginEnabled"
                :href="route('social.login', { provider: 'google' })"
                class="w-full"
              >
                <!-- class="flex cursor-pointer items-center space-x-3 rounded-lg border border-grayCust-390 px-4 py-2.5 shadow-sm hover:bg-grayCust-50 md:w-[280px]" -->
                <!-- <GoogleIcon class="size-4 md:size-6" />
                <span class="hidden font-semibold text-grayCust-620 md:block">Continue with Google</span> -->
                <AppCommonButton
                  btn-title="Continue with Google"
                  image-path="images/Login/google-icon.svg"
                  btn-type="gray-outline-btn"
                  size="btn-xl"
                  extra-class="!w-full"
                />
              </a>
              <a
                v-if="setting.facebookLoginEnabled"
                :href="route('social.login', { provider: 'facebook' })"
              >
                <!-- class="cursor-pointer rounded-lg border border-grayCust-390 px-4 py-2.5 shadow-sm hover:bg-grayCust-50" -->
                <!-- <FacebookIcon class="size-4 md:size-6" /> -->
                <AppIconButton
                  image-path="images/Login/facebook-icon.svg"
                  btn-type="gray-outline-btn"
                  size="btn-xxl"
                  extra-class="!w-full"
                />
              </a>
              <a
                v-if="setting.twitterLoginEnabled"
                :href="route('social.login', { provider: 'twitter' })"
              >
                <!-- class="cursor-pointer rounded-lg border border-grayCust-390 px-4 py-2.5 shadow-sm hover:bg-grayCust-50" -->
                <!-- <TwitterIcon class="size-4 md:size-6" /> -->
                <AppIconButton
                  image-path="images/Login/twitter-icon.svg"
                  btn-type="gray-outline-btn"
                  size="btn-xxl"
                  extra-class="!w-full"
                />
              </a>
            </div>
            <div
              v-if="setting.googleLoginEnabled || setting.facebookLoginEnabled || setting.twitterLoginEnabled"
              class="flex items-center gap-x-4"
            >
              <div class="h-0.5 w-full bg-grayCust-180" />
              <span class="text-xs text-grayCust-460">OR</span>
              <div class="h-0.5 w-full bg-grayCust-180" />
            </div>
            <div class="space-y-2 text-left text-grayCust-910 md:space-y-3">
              <label
                for="email"
                class="text-xs sm2:text-sm md:text-base"
              >Email</label>
              <div>
                <jet-input
                  id="email"
                  name="email"
                  type="email"
                  class="h-9 w-full rounded-lg border-transparent bg-grayCust-280 px-4 py-2.5 text-sm text-grayCust-1740 placeholder:text-base focus:border-primary-900 focus:ring focus:ring-primary-900 focus:ring-opacity-50 md:h-12 md:text-base"
                  required
                  autofocus
                />
              </div>
            </div>
            <div class="space-y-2 text-left text-grayCust-910 md:space-y-3">
              <label
                for="password"
                class="text-xs sm2:text-sm md:text-base"
              >Password</label>
              <div class="relative">
                <jet-input
                  id="password"
                  v-model="form.password"
                  name="password"
                  :type="showPassword ? 'text' : 'password'"
                  class="h-9 w-full rounded-lg border-transparent bg-grayCust-280 px-4 py-2.5 text-sm text-grayCust-1740 focus:border  focus:border-primary-900 focus:ring focus:ring-primary-900 focus:ring-opacity-50 md:h-12 md:text-base"
                  required
                  autocomplete="current-password"
                />
                <img
                  v-if="showPassword"
                  :src="cdn(`images/OnboardingFlow/eye-slash.svg`)"
                  alt=""
                  class="absolute right-0.5 top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 cursor-pointer md:size-6"
                  @click="showPassword = !showPassword"
                >
                <svg
                  v-if="!showPassword"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#52525B"
                  class="absolute right-0.5 top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 cursor-pointer md:size-6"
                  @click="showPassword = !showPassword"
                >
                  <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                  <path
                    fill-rule="evenodd"
                    d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div class="!mt-4 flex items-center justify-between md:mt-0">
              <div class="flex items-center gap-x-2">
                <input
                  id="remember"
                  type="checkbox"
                  name="remember"
                  class="size-3.5 rounded-full text-primary-900 focus:ring-0 md:size-[18px]"
                >
                <label
                  for="remember"
                  class="cursor-pointer text-xs font-medium text-grayCust-910 sm2:text-sm md:text-base"
                >Remember me</label>
              </div>
              <inertia-link
                :href="route('password.request')"
                class="cursor-pointer text-xs font-medium text-grayCust-640 sm2:text-sm md:text-base"
              >
                {{ $t('forgot_password') }}?
              </inertia-link>
            </div>
          </div>
          <div>
            <!-- <button
              :disabled="processing"
              type="submit"
              class="mt-0 flex h-9 w-full items-center justify-center rounded-lg bg-primary-900 px-4 py-2.5 text-sm font-semibold text-white focus:ring-2 focus:ring-primary-900 focus:ring-offset-2 disabled:opacity-60 md:mt-4 md:h-12 md:text-base"
            >
              {{ $t('sign_in') }}
            </button> -->
            <AppCommonButton
              :btn-title="$t('sign_in')"
              type="submit"
              btn-type="primary"
              :disabled="processing"
              size="btn-xl"
              extra-class="!w-full"
            />
          </div>
        </form>  
        <div class="flex items-center justify-center gap-x-2 text-xs sm2:text-sm md:text-lg">
          <span class="text-grayCust-910">{{ $t('you_have_not_any_account') }}?</span>
          <span
            class="cursor-pointer font-semibold text-primary-900"
            @click="onSignUpClick"
          >{{ $t('sign_up') }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FacebookIcon from '@/Common/Icons/Onboard/FacebookIcon.vue'
import GoogleIcon from '@/Common/Icons/Onboard/GoogleIcon.vue'
import InstaWpIcon from '@/Common/Icons/Onboard/InstaWpIcon.vue'
import TwitterIcon from '@/Common/Icons/Onboard/TwitterIcon.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import { useOnboardStore } from '@/onboard/store'
import Setting from '@/setting.js'
import moment from 'moment'
import { mapStores } from 'pinia'

export default {
    props: {
        plugin_theme_arr: {
            type: Array,
            default: []
        },
        status: String,
        isModalLogin: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapStores(useOnboardStore),
    },
    name: 'SignInPage',
    
    components:{
        InstaWpIcon,
        FacebookIcon,
        GoogleIcon,
        TwitterIcon,
        JetValidationErrors,
        JetInput,
        JetCheckbox
    },
    data() {
        return {
            redirect: '',
            csrf_token: document.querySelector('meta[name="csrf-token"]').content,
            processing: false,
            serverErrors: {},
            showPassword: false,
            form: {
                password:''
            },
            setting: new Setting(),
            timezone: moment.tz.guess()
        }
    },
    mounted() {
        const params = route().params;
        this.redirect = params?.redirect || null;
        if (this.$page.props.flash?.message) {
            this.onboardStore.setNotification(this.$page.props.flash?.message);
        }
    },
    updated() {
        if (this.$page.props.flash?.message) {
            this.onboardStore.setNotification(this.$page.props.flash?.message);
        }
    },
    methods: {
        onSignUpClick() {
            this.$emit('signupPage');
        },
    },
}
</script>

<style scoped>
@media (max-height: 720px) {
    .right-side-bg{
        bottom: 120px !important;
        right: 30px;
    }
}
@media (max-width: 744px) and (max-height: 720px){
    .right-side-bg{
        right: 105px !important;
    }
}
</style>